import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    getStructure(structureId) {
        return axios.get(`structures/${structureId}`)
    },

    listStructures() {
        return axios.get('structures')
    },

    listInitiatorUserStructures() {
        return axios.get('structures/list-initiator-user-structures')
    },
    listStructuresWithAnnualPlan() {
        return axios.get('structures/with-annual-plans')
    },

    listExternalStructures() {
        return axios.get('structures/external')
    },

    listOrganization(onlyActive) {
        return axios.get(`structures/organization?onlyActive=${onlyActive}`)
    },

    addStructure(structureObj) {
        return axios.post('structures', structureObj)
    },

    updateStructure(structureId, structureObj) {
        return axios.post(`structures/update/${structureId}`, structureObj)
    },

    deleteStructure(structureId) {
        return axios.post(`structures/delete/${structureId}`)
    },

    listUsersInStructure(structureId) {
        return axios.get(`structures/${structureId}/users`)
    },

    listRoles(structureId) {
        return axios.get(`structures/${structureId}/roles`)
    },

    removeUserFromStructure(structureId, userId) {
        return axios.post(`structures/${structureId}/delete-user/${userId}`)
    },

    addUserToStructure(structureId, userId, roleId) {
        return axios.post(`structures/${structureId}/add-user/${userId}/role/${roleId}`,)
    },
    listMunicipalities() {
        return axios.get('municipalities')
    },

    listUsersInMunicipality(municipalityId) {
        return axios.get(`municipalities/${municipalityId}/users`)
    },
    addUserToMunicipality(municipalityId, userId) {
        return axios.post(`municipalities/${municipalityId}/add-user/${userId}`,)
    },
    removeUserFromMunicipality(municipalityId, userId) {
        return axios.post(`municipalities/${municipalityId}/delete-user/${userId}`)
    },
    addMunicipality(municipalityObj) {
        return axios.post('municipalities', municipalityObj)
    },
    updateMunicipality(municipalityId, municipalityObj) {
        return axios.post(`municipalities/update/${municipalityId}`, municipalityObj)
    },
    addMunicipalityDesign(municipalityId, municipalityDesignObj) {
        return axios.post(`municipalities/${municipalityId}`, municipalityDesignObj)
    },
    getMunicipalityById(municipalityId) {
        return axios.get(`municipalities/${municipalityId}`)
    },
    listMunicipalitiesShared() {
        return axios.get('municipalities/listMunicipalitiesShared')
    },
}